// Dependencies
import { createGlobalStyle } from 'styled-components'
import {
  Colors,
  linguagens,
  natureza,
  comum,
  humanas,
  matematica,
  redacao
} from '../utils/colors'

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&family=Nunito:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@300;400;500;600;700;900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;500;700;900&display=swap');

  @font-face {
    font-family: 'Source Sans Pro';
    src: url(fonts/SourceSansPro-Regular.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Source Sans Pro';
    src: url(fonts/SourceSansPro-Black.ttf) format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Source Sans 3';
    src: url(fonts/SourceSans3-Regular.ttf) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Source Sans 3';
    src: url(fonts/SourceSans3-Bold.ttf) format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  html, body {
    scroll-behavior: smooth;
  }

  body, div {
    -webkit-font-smoothing: antialiased;
  }


  *, body, input, button, textarea, span, h1, h2, h3, h4, h5, h6 {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    outline: 0;
    border: 0;
    font-family: 'Source Sans 3', sans-serif;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  a {
    text-decoration: none;
  }

  button {
    cursor: pointer;
    outline: 0px;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  html,
  body {
    background-color: #ECEEEE;
  }

  input[type="number"] {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`

export const Theme = () => {
  return {
    colors: {
      ...Colors,
      linguagens,
      matematica,
      redacao,
      natureza,
      comum,
      humanas
    }
  }
}
